import gql from "graphql-tag";

export const GET_EMAIL_TEMPLATE = gql`
query GetEmailTemplate($companyName: String!) {
    getEmailTemplate(companyName: $companyName) {
    code
    success
    message
    results
  }
}`;


export const CREATE_EMAIL_TEMPLATE = gql`
mutation AddEmailTemplate($data: EmailTemplateInput!, $companyName: String!) {
  addEmailTemplate(data: $data, companyName: $companyName) {
    code
    success
    message
  }
}`;

export const UPDATE_EMAIL_TEMPLATE = gql`
mutation UpdateEmailTemplate($_id: ID!, $data: EmailTemplateInput!, $companyName: String!) {
  updateEmailTemplate( _id: $_id, data: $data, companyName: $companyName) {
    code
    success
    message
  }
}`;

export const DELETE_EMAIL_TEMPLATE= gql`
mutation DeleteEmailTemplate($_id: ID!, $companyName: String!) {
  deleteEmailTemplate(_id: $_id, companyName: $companyName) {
    code
    success
    message
  }
}`;






